// extracted by mini-css-extract-plugin
module.exports = {"section":"RelatedServices_section__8ZNFk","heading":"RelatedServices_heading__72ulF","grid":"RelatedServices_grid____ZRD","card":"RelatedServices_card__kUHeK"};